<app-links-item *ngIf="pivot != undefined && display" [color]="color" [icon]="icon" [labels]="pivot.labels" [uid]="pivot.uid">
  <div app-links-item-content-description>
    <div *ngIf="!links.has('pivots', uid)"><mdb-badge warning="true" class="z-depth-0">{{ 'REMOVE_WARNING/TEXT' | translate }}</mdb-badge></div>
    <div *ngIf="links.isReplaced('pivots', uid)"><mdb-badge info="true" class="z-depth-0">{{ 'LINKPIVOT_MODIFIED/TEXT' | translate }}</mdb-badge></div>
  </div>
  <div app-links-item-content-option>
    <app-links-item-option class="d-block mx-1" [symbol]="'check'" [selected]="links.has('pivots', uid)" (sendSelected)="receiveSelected()"></app-links-item-option>
  </div>
  <div app-links-item-content-option>
    <button (click)="onChange()" mdbBtn type="button" color="light" size="sm" class="px-2 z-depth-0 my-0 mr-0 ml-2" mdbWavesEffect>
      <i class="fas fa-link fa-fw {{ color }}-text"></i>
    </button>
  </div>
  <div app-links-item-content-sub>
    <div *ngIf="pivot && pivot?.uid?.isRegistered == false" class="mt-3 white p-2 rounded">
      <app-labels [labels]="pivot.labels" [color]="color"></app-labels>
    </div>
    <div class="blue-grey lighten-4 p-2 mt-3 rounded" *ngIf="isChanged && pivot">
      <app-pivots-links-change [exclude]="exclude" [pivot]="pivot" [withIcon]="false" (sendSelected)="receiveLinkChange($event)"></app-pivots-links-change>
    </div>
  </div>
</app-links-item>